module.exports = __webpack_public_path__ + "media/images/icons/country_flags/ec-0640a50e134c6a6db167e33b8b6b7c6f.svg";